module.exports = __webpack_public_path__ + "static/media/icon-time-of-day.0ed64210.svg";